import React, { useState, useEffect } from 'react';
import { AvatarType, AVATARS } from '../../../shared/constants/avatars';

interface CalmiCharacterProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  avatar?: AvatarType;
}

const CalmiCharacter: React.FC<CalmiCharacterProps> = ({ size = 'medium', className = '', avatar }) => {
  const [selectedAvatar, setSelectedAvatar] = useState<AvatarType>(() => {
    if (avatar) return avatar;
    const saved = localStorage.getItem('calmi_avatar');
    return (saved as AvatarType) || 'rabbit';
  });

  useEffect(() => {
    if (avatar) {
      setSelectedAvatar(avatar);
    } else {
      const saved = localStorage.getItem('calmi_avatar');
      if (saved) setSelectedAvatar(saved as AvatarType);
    }

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'calmi_avatar' && !avatar) {
        setSelectedAvatar((e.newValue as AvatarType) || 'rabbit');
      }
    };

    const handleCustomAvatarChange = (e: CustomEvent) => {
      if (!avatar) {
        setSelectedAvatar((e.detail as AvatarType) || 'rabbit');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('calmi-avatar-change', handleCustomAvatarChange as EventListener);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('calmi-avatar-change', handleCustomAvatarChange as EventListener);
    };
  }, [avatar]);
  const [isBlinking, setIsBlinking] = useState(false);

  const sizeClasses = {
    small: 'text-4xl sm:text-5xl',
    medium: 'text-6xl sm:text-7xl',
    large: 'text-8xl sm:text-9xl md:text-10xl'
  };

  const avatarData = AVATARS.find(a => a.id === selectedAvatar) || AVATARS[0];

  // Parpadeo automático cada 3-5 segundos
  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setIsBlinking(true);
      setTimeout(() => setIsBlinking(false), 150);
    }, 3000 + Math.random() * 2000);

    return () => clearInterval(blinkInterval);
  }, []);

  return (
    <div 
      className={`relative ${sizeClasses[size]} ${className} transition-transform duration-300 hover:scale-105`}
      style={{
        animation: 'float 3s ease-in-out infinite',
        opacity: isBlinking ? 0.7 : 1
      }}
    >
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
        `}
      </style>
      {avatarData.emoji}
    </div>
  );
};

export default CalmiCharacter;
